import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "batch-delete"
};
const _hoisted_2 = {
  class: "batch-operation-table"
};
const _hoisted_3 = {
  class: "btn-group"
};
import { ref, toRefs, onMounted, computed, watch } from 'vue';
import { queryComponent, refreshstructure, deleteserver } from '@/api/management/batchOperation';
import { useUserDefaultSettingStore } from '@/store/user';
import { ElMessage, ElMessageBox } from 'element-plus';
import { useBatchOperationStore } from '@/store/batchOperation';
import { storeToRefs } from 'pinia';
export default /*@__PURE__*/_defineComponent({
  __name: 'batch-delete-dialog',
  props: {
    visible: {
      type: Boolean
    },
    checkIdList: {}
  },
  emits: ["confirm", "update:visible"],
  setup(__props, {
    emit: __emit
  }) {
    const batchOperationStore = useBatchOperationStore();
    const {
      refreshTable
    } = storeToRefs(batchOperationStore);
    const userStore = useUserDefaultSettingStore();
    const {
      userName
    } = storeToRefs(userStore);
    const props = __props;
    const {
      visible,
      checkIdList
    } = toRefs(props);
    const tableData = ref([]);
    const initTable = async () => {
      const ids = checkIdList.value.join('_');
      const {
        ServerList
      } = await queryComponent(ids, 0, 0);
      tableData.value = ServerList;
    };
    const computedTableData = computed(() => tableData.value.slice((currentPage.value - 1) * pageSize.value, currentPage.value * pageSize.value));
    const currentPage = ref(1);
    const pageSize = ref(10);
    const itemNumber = computed(() => tableData.value.length);
    const handleDelete = async () => {
      ElMessageBox.prompt('Are you sure to delete these Checks? Please input reason.', 'Confirm', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'Cancel',
        inputPattern: /^[a-zA-Z0-9\s\-._~!$&'()*+,;=:@]+$/,
        inputErrorMessage: 'Invalid Reason'
      }).then(({
        value
      }) => {
        deleteAgent(value);
      });
    };
    const deleteAgent = async reason => {
      await refreshstructure();
      ElMessage({
        type: 'success',
        message: 'Deleting checks...'
      });
      const ids = checkIdList.value.join('_');
      await deleteserver(ids, userName.value, reason);
      ElMessage({
        type: 'success',
        message: 'Deleting completed'
      });
      refreshTable.value++;
      handleBeforeClose();
    };
    const emits = __emit;
    const dialogVisible = ref(false);
    const handleBeforeClose = () => {
      emits('update:visible', false);
    };
    const handleCancel = () => {
      emits('update:visible', false);
    };
    onMounted(() => {
      dialogVisible.value = visible.value;
    });
    watch(() => visible.value, () => {
      dialogVisible.value = visible.value;
      if (dialogVisible.value) {
        initTable();
      }
    });
    return (_ctx, _cache) => {
      const _component_dialog_header = _resolveComponent("dialog-header");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => dialogVisible.value = $event),
        "show-close": false,
        width: "60%",
        "before-close": handleBeforeClose
      }, {
        header: _withCtx(({
          close
        }) => [_createVNode(_component_dialog_header, {
          onClose: close,
          "header-name": "Batch Delete"
        }, null, 8, ["onClose"])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_table, {
          data: computedTableData.value,
          style: {
            "width": "99%"
          },
          "row-key": "id",
          border: "",
          "default-expand-all": ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            type: "index",
            index: index => index + 1
          }, null, 8, ["index"]), _createVNode(_component_el_table_column, {
            prop: "clusterName",
            label: "Cluster"
          }), _createVNode(_component_el_table_column, {
            prop: "zoneName",
            label: "Zone"
          }), _createVNode(_component_el_table_column, {
            prop: "serverIp",
            label: "Check"
          })]),
          _: 1
        }, 8, ["data"]), _createVNode(_component_el_pagination, {
          "current-page": currentPage.value,
          "onUpdate:currentPage": _cache[0] || (_cache[0] = $event => currentPage.value = $event),
          "page-size": pageSize.value,
          "onUpdate:pageSize": _cache[1] || (_cache[1] = $event => pageSize.value = $event),
          "page-sizes": [10, 20, 50],
          layout: "total, sizes, prev, pager, next",
          class: "batch-operation-pagination mt-10",
          total: itemNumber.value
        }, null, 8, ["current-page", "page-size", "total"])]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_button, {
          plain: "",
          onClick: handleCancel
        }, {
          default: _withCtx(() => _cache[3] || (_cache[3] = [_createTextVNode("Cancel")])),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "danger",
          onClick: handleDelete
        }, {
          default: _withCtx(() => _cache[4] || (_cache[4] = [_createTextVNode("Delete")])),
          _: 1
        })])])]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
});